const { upgradeArray } = require('../utils')

const DEFAULT_CACHE_KEYS = [ '#meta._requestSource', '#meta.user.id', '#meta.asUser.id' ]

const REST_ACTIONS = upgradeArray([ 'get', 'find', 'create', 'update', 'remove' ])
const MODERATION_VALUES = upgradeArray([ 'approved', 'rejected', 'pending' ])
const PROTOCOL_TYPES = upgradeArray([ 'smpp', 'http', 'smtp', 'websocket-serve', 'websocket-client' ])

const COMPARATORS = upgradeArray([ 'regexp', 'pattern', 'lt', 'lte', 'gt', 'gte', 'eq' ])

const SCHEMA_RENDER_TYPES = upgradeArray([
  'select',
  'switch',
  'input',
  'color',
  'kvgen',
  'variable',
  'textarea',
  'label',
  'kvv'
])
const GENDERS = upgradeArray([ 'male', 'female' ])

const WEBHOOK_EVENTS = upgradeArray([ 'onStatusChange', 'onIncomingMessage' ])
const WEBSOCKET_CHANNELS = upgradeArray([ 'everything', 'dbUpdates', 'health', 'sendingStatusUpdates', 'providersStatesUpdates' ])

const DEFAULT_VALUE = '$default'

module.exports = {
  DEFAULT_CACHE_KEYS,
  REST_ACTIONS,
  MODERATION_VALUES,
  PROTOCOL_TYPES,
  COMPARATORS,
  SCHEMA_RENDER_TYPES,
  GENDERS,
  WEBHOOK_EVENTS,
  WEBSOCKET_CHANNELS,
  DEFAULT_VALUE
}
